import { getAccessToken } from '../app/Auth/Auth';

const callApi = async (method: string, url: string, path: string, data?: any) => {
  try {
    const headers: any = {
      Accept: 'application/json',
      Authorization: `Bearer ${getAccessToken()}`,
      'Content-Type': 'application/json',
    };

    const nickname = localStorage.getItem("nickname");
    if (nickname) {
      headers.nickname = nickname;
    }

    const res = await fetch(url + '/api' + path, {
      method,
      headers,
      body: JSON.stringify(data),
    });
    return await res.json();
  } catch (error) {
    return { error };
  }
};

export default callApi;
